import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-8074">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-8075">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-8076">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-8077">
            <ArrowLeft className="w-4 h-4" data-id="element-8078" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-8079">NOIZA</div>
          <div className="w-20" data-id="element-8080" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-8081">
        <div className="mb-12" data-id="element-8082">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-8083">
            <FileText className="w-6 h-6 text-white/80" data-id="element-8084" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-8085">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-8086">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-8087">
          <section data-id="element-8088">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8089">
              <span className="text-[#006847]" data-id="element-8090">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8091">
              <p data-id="element-8092">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-8093">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8094">
                <li data-id="element-8095">Haber leído íntegramente este documento</li>
                <li data-id="element-8096">Comprender su contenido en su totalidad</li>
                <li data-id="element-8097">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-8098">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-8099">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8100">
              <span className="text-[#006847]" data-id="element-8101">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8102">
              <p data-id="element-8103">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8104">
                <li data-id="element-8105">Software como servicio (SaaS)</li>
                <li data-id="element-8106">Marketplace digital gastronómico</li>
                <li data-id="element-8107">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8108">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8109">
                <li data-id="element-8110">Mostrar su menú digital</li>
                <li data-id="element-8111">Recibir pedidos de clientes</li>
                <li data-id="element-8112">Gestionar su operación interna</li>
                <li data-id="element-8113">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8114">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8115">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8116">
              <span className="text-[#006847]" data-id="element-8117">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8118">
              <p data-id="element-8119">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8120">
                <li data-id="element-8121">No es proveedor de alimentos</li>
                <li data-id="element-8122">No participa en la preparación de productos</li>
                <li data-id="element-8123">No manipula alimentos en ningún momento</li>
                <li data-id="element-8124">No realiza entregas ni logística</li>
                <li data-id="element-8125">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8126">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8127">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8128">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8129">
              <span className="text-[#006847]" data-id="element-8130">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8131">
              <p data-id="element-8132">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8133">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8134">
                <li data-id="element-8135">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8136">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8137">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8138">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8139">
                <li data-id="element-8140">Precios</li>
                <li data-id="element-8141">Menú</li>
                <li data-id="element-8142">Horarios</li>
                <li data-id="element-8143">Métodos de pago</li>
                <li data-id="element-8144">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8145">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8146">
              <span className="text-[#006847]" data-id="element-8147">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8148">
              <div data-id="element-8149">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8150">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8151">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8152">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8153">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8154">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8155">
                  <li data-id="element-8156">Calidad de los alimentos</li>
                  <li data-id="element-8157">Estado, frescura o preparación</li>
                  <li data-id="element-8158">Ingredientes utilizados</li>
                  <li data-id="element-8159">Contaminación cruzada</li>
                  <li data-id="element-8160">Problemas de higiene o salubridad</li>
                  <li data-id="element-8161">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8162">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8163">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8164">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8165">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8166">
                  <li data-id="element-8167">Retrasos en la entrega</li>
                  <li data-id="element-8168">Pérdida de pedidos</li>
                  <li data-id="element-8169">Entregas incompletas</li>
                  <li data-id="element-8170">Errores en dirección</li>
                  <li data-id="element-8171">Conducta de repartidores</li>
                  <li data-id="element-8172">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8173">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8174">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8175">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8176">
                  <li data-id="element-8177">Recepción de pagos</li>
                  <li data-id="element-8178">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8179">Manejo de efectivo</li>
                  <li data-id="element-8180">Confirmación de pagos</li>
                  <li data-id="element-8181">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8182">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8183">
                  <li data-id="element-8184">Pagos no recibidos</li>
                  <li data-id="element-8185">Comprobantes falsos</li>
                  <li data-id="element-8186">Errores en montos</li>
                  <li data-id="element-8187">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8188">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8189">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8190">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8191">
                  <li data-id="element-8192">Reclamos de clientes</li>
                  <li data-id="element-8193">Reembolsos</li>
                  <li data-id="element-8194">Cancelaciones</li>
                  <li data-id="element-8195">Disputas</li>
                  <li data-id="element-8196">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8197">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8198">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8199">
              <span className="text-[#006847]" data-id="element-8200">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8201">
              <p data-id="element-8202">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8203">
                <li data-id="element-8204">Responsable</li>
                <li data-id="element-8205">Legal</li>
                <li data-id="element-8206">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8207">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8208">
                <li data-id="element-8209">Publicar información falsa</li>
                <li data-id="element-8210">Manipular precios de forma engañosa</li>
                <li data-id="element-8211">Simular disponibilidad inexistente</li>
                <li data-id="element-8212">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8213">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8214">
              <span className="text-[#006847]" data-id="element-8215">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8216">
              <p data-id="element-8217">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8218">
                <li data-id="element-8219">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8220">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8221">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8222">
                <li data-id="element-8223">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8224">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8225">
                    <li data-id="element-8226">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8227">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8228">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8229">
              <span className="text-[#006847]" data-id="element-8230">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8231">
              <p data-id="element-8232">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8233">
                <li data-id="element-8234">Menú digital</li>
                <li data-id="element-8235">Gestión de pedidos</li>
                <li data-id="element-8236">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8237">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8238">
                  <p className="font-medium text-white mb-2" data-id="element-8239">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8240">
                    <li data-id="element-8241">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8242">
                  <p className="font-medium text-white mb-2" data-id="element-8243">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8244">
                    <li data-id="element-8245">Propiedad del software</li>
                    <li data-id="element-8246">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8247">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8248">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8249">
              <span className="text-[#006847]" data-id="element-8250">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8251">
              <p data-id="element-8252">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8253">
                <li data-id="element-8254">Disponibilidad continua</li>
                <li data-id="element-8255">Funcionamiento sin interrupciones</li>
                <li data-id="element-8256">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8257">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8258">
                <li data-id="element-8259">Fallas técnicas</li>
                <li data-id="element-8260">Actualizaciones</li>
                <li data-id="element-8261">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8262">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8263">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8264">
              <span className="text-[#006847]" data-id="element-8265">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8266">
              <p data-id="element-8267">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8268">
                <li data-id="element-8269">No está garantizada permanentemente</li>
                <li data-id="element-8270">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8271">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8272">
                <li data-id="element-8273">Destacar o no restaurantes</li>
                <li data-id="element-8274">Modificar posiciones</li>
                <li data-id="element-8275">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8276">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8277">
              <span className="text-[#006847]" data-id="element-8278">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8279">
              <p data-id="element-8280">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8281">
                <li data-id="element-8282">Cumplir con los pagos acordados</li>
                <li data-id="element-8283">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8284">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8285">
                <li data-id="element-8286">Suspender el servicio</li>
                <li data-id="element-8287">Limitar funcionalidades</li>
                <li data-id="element-8288">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8289">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8290">
              <span className="text-[#006847]" data-id="element-8291">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8292">
              <p data-id="element-8293">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8294">
                <li data-id="element-8295">Incumplimiento de términos</li>
                <li data-id="element-8296">Uso indebido</li>
                <li data-id="element-8297">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8298">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8299">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8300">
              <span className="text-[#006847]" data-id="element-8301">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8302">
              <p data-id="element-8303">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8304">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8305">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8306">
              <span className="text-[#006847]" data-id="element-8307">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8308">
              <p data-id="element-8309">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8310">
                <li data-id="element-8311">Pérdidas económicas</li>
                <li data-id="element-8312">Daños indirectos</li>
                <li data-id="element-8313">Lucro cesante</li>
                <li data-id="element-8314">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8315">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8316">
              <span className="text-[#006847]" data-id="element-8317">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8318">
              <p data-id="element-8319">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8320">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8321">
              <span className="text-[#006847]" data-id="element-8322">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8323">
              <p className="font-medium" data-id="element-8324">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8325">
                <li data-id="element-8326">Ha leído este documento completo</li>
                <li data-id="element-8327">Comprende su alcance</li>
                <li data-id="element-8328">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}